import { createAction } from 'app-components/flux/core/actionHelpers';
import { actionHelpers } from '../core';

export const getIdentities = createAction('GET_IDENTITIES');
export const getIdentitiesSuccess = createAction('GET_IDENTITIES_SUCCESS');
export const getIdentitiesFailure = createAction('GET_IDENTITIES_FAILURE');

export const createIdentity = createAction('CREATE_IDENTITY', actionHelpers.payloadCreate, (payload, meta) => meta);
export const createIdentitySuccess = createAction(
  'CREATE_IDENTITY_SUCCESS',
  (payload) => payload,
  (payload, meta) => meta,
);
export const createIdentityFailure = createAction('CREATE_IDENTITY_FAILURE');

export const updateIdentity = createAction(
  'UPDATE_IDENTITY',
  (payload) => payload,
  (payload, meta) => meta,
);
export const updateIdentitySuccess = createAction('UPDATE_IDENTITY_SUCCESS');
export const updateIdentityFailure = createAction('UPDATE_IDENTITY_FAILURE');

export const deleteIdentity = createAction('DELETE_IDENTITY', actionHelpers.payloadDelete, (payload, meta) => meta);
export const deleteIdentitySuccess = createAction('DELETE_IDENTITY_SUCCESS');
export const deleteIdentityFailure = createAction('DELETE_IDENTITY_FAILURE');
